import { ActionItemStatus } from "@digits-graphql/frontend/graphql-bearer"

export const STATUS_OPEN = [ActionItemStatus.Created]

export const STATUS_RESOLVED = [ActionItemStatus.Closed, ActionItemStatus.Completed]
